import React, { useState, useEffect, useRef } from 'react';
import BaseSection from 'commonComponents/sections/BaseSection/BaseSection';
import styles from './Problems.module.scss';

const Problems = ({ headers, text, list }) => {
  return (
    <BaseSection
      { ...headers }
      anchor='propblems'
    >
      <p className={ styles.text }>{ text }</p>
      { list && <ProblemsList list={ list } /> }
    </BaseSection>
  );
};

const ProblemsList = ({ list }) => {

  const [listNodesHeights, setListNodesHeights] = useState([]);
  const [maxHeight, setMaxHeight] = useState(0);

  useEffect(() => {
    if(listNodesHeights.length === list.length) {
      setMaxHeight(Math.max(...listNodesHeights));
    }    
  }, [listNodesHeights]);

  return (
    <ol className={ styles.ProblemsList }>
      { list.map((item, i) => (
        <ProblemsListItem
          key={item}
          number={i + 1}
          text={item}
          height={maxHeight}
          setListNodesHeights={setListNodesHeights}
        />
      )) }
    </ol>
  );
};

const ProblemsListItem = ({ number, text, height, setListNodesHeights }) => {

  const itemNode = useRef(null);
  const style = height ? { height } : {};

  useEffect(() => {
    setListNodesHeights(prev => {
      const heights = [...prev];
      heights.push(itemNode.current.clientHeight);
      return heights;
    }); 
  }, []);

  return (
    <li ref={itemNode} style={style}>
      <span className={styles.number}>{number}</span>
      <span className={styles.text}>{text}</span>
    </li>
  );
};
 
export default Problems;
